enum LANGUAGES {
  PL = 'pl',
  EN = 'en',
  DE = 'de',
}

export default LANGUAGES;
